import { Space } from "components/Common/Space";
import { ExerciseHeader } from "components/Common/ExerciseHeader";
import {
  useUpdateChapterStudentProgress,
  useUpdateHomeworkStudentProgress,
} from "hooks/api/student-progress";
import { useRole } from "hooks/common";
import { useParams } from "react-router-dom";
import { ExerciseContainer } from "./ExerciseContainer";
import {
  TCompareImageWithDescriptionExercise,
  TCompareImageWithDescriptionExercisePayload,
} from "types/app/exercises";
import "./CompareImageWithDescription.styles.scss";

type TCompareImageWithDescriptionProps = {
  isHomeworkExercise: boolean;
  /**
   * Chapter ID to which the exercise belongs.
   */
  chapterId: number;
  /**
   * An exercise raw data from API response.
   */
  exercise: TCompareImageWithDescriptionExercise;
  /**
   * Lesson chapter order number with the exercise sequence number to display before the exercise condition.
   * @default null
   */
  prefix?: string | null;
};

export const CompareImageWithDescription: React.FC<
  TCompareImageWithDescriptionProps
> = (props) => {
  const { chapterId, exercise, prefix = null, isHomeworkExercise } = props;

  const { courseId, lessonId, studentId } = useParams();
  const { isUserStudent } = useRole();

  const { mutate: updateChapterProgress } = useUpdateChapterStudentProgress(
    courseId,
    lessonId,
    chapterId,
    studentId
  );
  const { mutate: updateHomeworkProgress } = useUpdateHomeworkStudentProgress(
    courseId,
    lessonId,
    chapterId,
    studentId
  );

  const handleSaveExercise = (
    updatedExercise: TCompareImageWithDescriptionExercise
  ) => {
    if (!isUserStudent || !studentId) return;

    if (isHomeworkExercise) {
      updateHomeworkProgress(updatedExercise);
    } else {
      updateChapterProgress(updatedExercise);
    }
  };

  return (
    <Space direction="vertical" size="medium" justify="start" fullWidth>
      <ExerciseHeader<TCompareImageWithDescriptionExercisePayload>
        chapterId={chapterId}
        exercise={exercise}
        prefix={prefix}
      />
      <ExerciseContainer
        exercise={exercise}
        onSaveExercise={handleSaveExercise}
      />
    </Space>
  );
};
